<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card p-fluid outlook-sync-settings">
        <h4>What Outlook may change in the CRM</h4>
        <p class="hint">
          Tasks and events the CRM puts in Outlook can be changed there too. Choose which changes come back into the CRM.
          Admin only.
        </p>

        <div v-if="loading" class="p-text-center"><ProgressSpinner /></div>

        <div v-else-if="loadError" id="loadError" class="p-invalid">{{ loadError }}</div>

        <div v-else>
          <div v-for="group in groups" :key="group.key" class="p-mb-4" :id="'group-' + group.key">
            <h5>{{ group.header }}</h5>
            <div v-for="f in group.fields" :key="f.key" class="p-mb-3">
              <div class="p-field p-d-flex p-ai-center p-mb-1">
                <InputSwitch :id="f.key" v-model="form[f.key]" />
                <label :for="f.key" class="p-ml-2 p-mb-0">{{ f.label }}</label>
              </div>
              <small v-if="f.help" class="hint p-d-block">{{ f.help }}</small>
              <small v-if="!form[f.key] && offText(f)" class="hint p-d-block off-help">{{ offText(f) }}</small>
              <small v-if="errors[f.key]" class="p-invalid p-d-block">{{ errors[f.key] }}</small>
            </div>
          </div>

          <p id="tieHelp" class="hint">{{ tieText }}</p>

          <div class="p-d-flex p-jc-end">
            <Button id="saveOutlookSync" label="Save" icon="pi pi-check" class="p-button-success" style="width: auto"
              :loading="saving" :disabled="saving" @click="save" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OutlookSyncService, { errorMessage, fieldErrors } from '@/service/OutlookSyncService'
import { SYNC_GROUPS, OFF_HELP, toForm, toBody, tieHelp } from './outlookSync'

export default {
  data: () => ({
    groups: SYNC_GROUPS,
    offHelp: OFF_HELP,
    form: toForm(null),
    tieSeconds: 60,
    errors: {},
    loading: true,
    loadError: '',
    saving: false
  }),
  computed: {
    tieText() { return tieHelp(this.tieSeconds) }
  },
  created() {
    this.outlookSyncService = new OutlookSyncService()
    this.load()
  },
  methods: {
    // A field's own offHelp ('' = none) replaces the page's "ignored and put back" text.
    offText(f) { return f.offHelp === undefined ? this.offHelp : f.offHelp },
    load() {
      this.loading = true
      return this.outlookSyncService.getSettings()
        .then(saved => this.show(saved))
        .catch(err => {
          this.loadError = errorMessage(err, 'The Outlook settings could not be loaded.')
        })
        .finally(() => { this.loading = false })
    },
    show(saved) {
      this.form = toForm(saved)
      this.tieSeconds = saved && saved.tieSeconds
      this.errors = {}
      this.loadError = ''
    },
    save() {
      if (this.saving) return
      this.saving = true
      this.errors = {}
      return this.outlookSyncService.saveSettings(toBody(this.form))
        .then(saved => {
          this.show(saved)
          this.$toast.add({ severity: 'success', summary: 'Saved', detail: 'What Outlook may change in the CRM is saved.', life: 4000 })
        })
        .catch(err => {
          this.errors = fieldErrors(err)
          this.$toast.add({ severity: 'error', summary: 'Not saved', detail: errorMessage(err, 'The Outlook settings could not be saved.'), life: 6000 })
        })
        .finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.hint { color: #6c757d; }
</style>
